module.exports = __webpack_public_path__ + "static/img/cover1.7b70c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cover1.png
// module id = HlCU
// module chunks = 16